import api from './utilBackoffice';

const controller = 'LogErroValidador3044';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto)
});
